import { Button } from "@bigbinary/neeto-atoms";
import PropTypes from "prop-types";

const SubTitle = ({ children, iconProps, ...otherProps }) => (
  <div
    className="my-5 flex items-center justify-between"
    data-testid={otherProps["data-testid"] || "menubar-subtitle-heading"}
    {...otherProps}
  >
    {children}
    <div className="flex items-center gap-1">
      {iconProps?.map(({ icon: Icon, onClick, ...rest }, index) => (
        <Button
          {...{ onClick }}
          key={index}
          size="icon-sm"
          variant="ghost"
          {...rest}
        >
          {Icon && <Icon size={16} />}
        </Button>
      ))}
    </div>
  </div>
);

SubTitle.propTypes = {
  children: PropTypes.node,
  iconProps: PropTypes.array,
};

export default SubTitle;
